import { FigPalette as FP } from './fig-palette';

export const figTextColors = {
  DEFAULT: FP.Grey.$800,
  base: FP.Grey.$800,
  inverted: FP.White,
  invers: FP.White, // DEPRECATED
  active: FP.Pistachio.$800,
  success: FP.Pistachio.$600,
  light: FP.Grey.$600,
  disabled: FP.Grey.$400,
  error: FP.Error,
  bullet: {
    DEFAULT: FP.Cornflower.$300,
    S: FP.Cornflower.$500,
    line: FP.Cornflower.$100,
  },
  link: {
    DEFAULT: FP.Cornflower.$500,
    sec: FP.Grey.$600,
  },
  acc: {
    lav: FP.Lavender.$600,
    blue: FP.Blue.$600,
    aqua: FP.Aqua.$700,
  },
};

export const figBorderColors = {
  base: FP.Grey.$300,
  divider: {
    DEFAULT: FP.Grey.$200,
    darker: FP.Grey.$400,
  },
  login: {
    DEFAULT: FP.Grey.$300,
    open: FP.Cornflower.$500,
    selected: FP.Pistachio.$500,
    error: FP.Watermelon.$500,
  },
};

export const figSurfaceColors = {
  base: FP.White,
  plain: FP.White,
  neutral: FP.Grey.$100,
  success: FP.Pistachio.$100, // tacho
  info: FP.Cornflower.$100,
  warning: FP.Orange.$100, // tacho
  error: FP.Watermelon.$100, // tacho
  watermelonX: FP.Watermelon.$100, // wording
  watermelon: FP.Watermelon.$100, // wording
  orange: FP.Orange.$100,
  prim: {
    DEFAULT: FP.Cornflower.$50,
    H: FP.Cornflower.$100,
  },
  sec: {
    // this should be prim but sec is cornflower otherwise
    DEFAULT: FP.Grey.$50,
    H: FP.Grey.$100,
  },
  tert: {
    RENAME: FP.Grey.$200,
  },
  subdim: {
    1: FP.Blue.$100,
    2: FP.Lavender.$100,
    3: FP.Aqua.$100,
    4: FP.Watermelon.$100,
    5: FP.Orange.$100,
    6: FP.Watermelon.$200,
    7: FP.Pistachio.$100,
  },
  brandfit: {
    DEFAULT: FP.Grey.$100,
    success: FP.Pistachio.$200,
    error: FP.Watermelon.$200,
    wording: FP.Watermelon.$100,
    compositions: FP.Orange.$100,
    info: FP.Cornflower.$100,
    warning: FP.Orange.$100,
    spelling: FP.Watermelon.$100,
    grammar: FP.Orange.$100,
    suggestion: FP.Cornflower.$100,
    delete: FP.Watermelon.$100,
  },
  marker: {
    lav: FP.Lavender.$100,
    blue: FP.Blue.$100,
    aqua: FP.Aqua.$100,
    change: FP.Cornflower.$400,
    ai: FP.Cornflower.$400,
    // additional colors for wordlist markers
    error: FP.Watermelon.$100,
    serror: FP.Watermelon.$400,
    warning: FP.Orange.$100,
    swarning: FP.Orange.$400,
    neutral: FP.Cornflower.$100,
    sneutral: FP.Cornflower.$400,
    correct: FP.Pistachio.$100,
    sncorrect: FP.Pistachio.$400,
  },
  btn: {
    disabled: FP.Grey.$100,
    cta: {
      DEFAULT: FP.Pistachio.$600,
      H: FP.Pistachio.$700,
      S: FP.Pistachio.$700,
    },
    prim: {
      DEFAULT: FP.Cornflower.$500,
      H: FP.Cornflower.$600,
      S: FP.Cornflower.$600,
    },
    sec: {
      DEFAULT: FP.Grey.$200,
      H: FP.Grey.$300,
      S: FP.Grey.$300,
    },
    tert: {
      DEFAULT: FP.White,
      H: FP.Grey.$100,
      S: FP.Pistachio.$100,
    },
  },

  toggle: {
    DEFAULT: FP.Transparent,
    H: FP.Grey.$100,
    S: FP.Cornflower.$50,
    SH: FP.Grey.$100,
  },

  tooltip: {
    DEFAULT: FP.Grey.$200,
    S: FP.Pistachio.$200,
  },
  tpi: {
    neutral: FP.Grey.$100,
    good: FP.Pistachio.$500,
    bad: FP.Orange.$500,
  },
  switch: {
    DEFAULT: FP.Grey.$500,
    S: FP.Pistachio.$600,
    disabled: FP.Grey.$300,
  },
  divider: {
    DEFAULT: FP.Grey.$200,
    dark: FP.Grey.$400,
  },

  tabs: {
    DEFAULT: FP.Grey.$100,
    H: FP.Grey.$200,
    from: FP.Pistachio.$100,
    to: FP.Aqua.$200,
  },
  dropdown: {
    DEFAULT: FP.Cornflower.$50,
    H: FP.Cornflower.$100,
    S: FP.Cornflower.$100,
    D: FP.Grey.$100, // this should be DEFAULT?
  },
  dropdownlogin: {
    DEFAULT: FP.White,
    H: FP.Grey.$50,
  },
  login: {
    cursor: FP.Cornflower.$500,
    start: FP.Blue.$100,
    end: { DEFAULT: FP.Pistachio.$100 },
  },

  // TODO: fix select... colors
  select: {
    config: {
      DEFAULT: FP.White,
      H: FP.White,
    },
    dropdown: {
      DEFAULT: FP.Cornflower.$100,
      H: FP.Cornflower.$50,
    },
    paragraph: {
      H: FP.Cornflower.$50,
      S: FP.Cornflower.$100,
    },
  },
};
